<script>
  export let view_node;
  export let title;
  export let nothing;
  export let created;
  export let body;
  export let field_media_image;
  export let news_topic;

</script>



<div class="row card-row">


  <div class="{field_media_image  ? 'col-lg-9' : 'col-lg-12'} ">

    {@html news_topic}
    <h2 class="title-item-teaser">
      <a href="{ view_node }">
        {@html title }
      </a>
    </h2>
    <div><h3 class="date-item-teaser">{ created}</h3></div>
    {#if nothing}
      <div class="item-field-content"><h3>{@html nothing }</h3></div>
    {/if}
    <div class="summary-content">
      {@html body }
    </div>
  </div>

    {#if field_media_image}
      <div class="col-lg-3">
        <img class="img-fluid" src="{ field_media_image}"
             alt="{ title}" title="{ title }" />
      </div>
    {/if}

</div>

